import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  CircularProgress,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import { FaCheck, FaTimes } from "react-icons/fa";
import "../AgentWithdrawlRequests/AgentWithdrawlRequests.css";
import { axiosInstance } from "../../axiosInstance";
import { toast } from "react-toastify";
import { GoSearch } from "react-icons/go";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { GoDownload } from "react-icons/go";
import { FiSend } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Table columns
const columns = [
  { id: "id", label: "INVITED ID", minWidth: 120, align: "center" },
  { id: "user", label: "USER", minWidth: 150, align: "center" },
  {
    id: "invited_user_name",
    label: "INVITED USERNAME",
    minWidth: 150,
    align: "center",
  },
  {
    id: "mobile_number",
    label: "INVITED MOBILE NUMBER",
    minWidth: 150,
    align: "center",
  },
  {
    id: "invited_user_location",
    label: "INVITED USER LOCATION",
    minWidth: 150,
    align: "center",
  },
  {
    id: "created_at",
    label: "INVITED DATE",
    minWidth: 150,
    align: "center",
  },

  //   { id: "actions", label: "ACTIONS", minWidth: 150, align: "center" },
];

const formatDate = (dateString) => {
  if (!dateString) return "--";
  const date = new Date(dateString);
  if (isNaN(date)) return "--";
  return date.toLocaleDateString("en-GB");
};

export function Invitations() {
  const [error, setError] = useState("");
  const [userInvitedList, setUserInvitedList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [activeEdit, setactiveEdit] = useState("wholesaler");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const fetchUserInvitations = async () => {
    setLoading(true);
    setError("");
    try {
      let config;

      if (activeEdit === "wholesaler") {
        config = {
          params: {
            user_type: "wholesaler",
            search: searchQuery,
            page: page + 1,
            page_size: rowsPerPage,
          },
        };
      } else {
        config = {
          params: {
            user_type: "retailer",
            search: searchQuery,
            page: page + 1,
            page_size: rowsPerPage,
          },
        };
      }

      const res = await axiosInstance.get("/admin/user-invited-list/", config);
      if (res.data.status === "success") {
        setUserInvitedList(res.data.data.results || []);
        setTotalCount(res.data.data.count || 0);
      } else {
        setError("Failed to fetch invitation list.");
      }
    } catch (err) {
      console.error("Error fetching invitation list:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPage(0);
    setDateRange([null, null]);
  }, [activeEdit, searchQuery]);

  useEffect(() => {
    fetchUserInvitations();
  }, [page, rowsPerPage, searchQuery, activeEdit]);

  // date filter
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const applyDateFilters = async (selectedRange) => {
    if (!selectedRange[0] || !selectedRange[1]) {
      toast.warning("Please select date range");
      return;
    } // no date selected

    setLoading(true);
    setError("");
    try {
      let config;
      if (activeEdit === "wholesaler") {
        config = {
          params: {
            user_type: "wholesaler",
            from_date: dayjs(selectedRange[0]).format("DD-MM-YYYY"),
            to_date: dayjs(selectedRange[1]).format("DD-MM-YYYY"),
          },
        };
      } else {
        config = {
          params: {
            user_type: "retailer",
            from_date: dayjs(selectedRange[0]).format("DD-MM-YYYY"),
            to_date: dayjs(selectedRange[1]).format("DD-MM-YYYY"),
          },
        };
      }

      const res = await axiosInstance.get("/admin/user-invited-list/", config);
      if (res.data.status === "success") {
        setUserInvitedList(res.data.data.results || []);
        setTotalCount(res.data.data.count || 0);
      } else {
        setError("Filter failed.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong.");
    } finally {
      setLoading(false);
      setPage(0);
    }
  };

  const clearDateFilters = () => {
    //clear date filters
    setDateRange([null, null]);
    fetchUserInvitations();
  };

  async function handleDownload() {
    try {
      if (!dateRange?.[0] || !dateRange?.[1]) {
        toast.warning("Please select date range");
        return;
      }
      setLoader(true);
      let payload;

      if (activeEdit === "wholesaler") {
        payload = {
          user_type: "wholesaler",
          from_date: dayjs(dateRange[0]).format("YYYY-MM-DD"),
          to_date: dayjs(dateRange[1]).format("YYYY-MM-DD"),
        };
      } else {
        payload = {
          user_type: "retailer",
          from_date: dayjs(dateRange[0]).format("YYYY-MM-DD"),
          to_date: dayjs(dateRange[1]).format("YYYY-MM-DD"),
        };
      }

      const response = await axiosInstance.post(
        `/admin/user-invited-excel-download/`,
        payload,
        {
          responseType: "blob", // required
        },
      );

      if (response.status === 200) {
        // const blob = new Blob([response.data], { type: "application/pdf" });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        // Try server-provided filename
        // const contentDisposition = response.headers["content-disposition"];
        // let fileName = "invoice.pdf";
        // // let fileName;
        // if (contentDisposition) {
        //   const match = contentDisposition.match(/filename="?(.+)"?/);
        //   if (match && match[1]) fileName = match[1];
        // }

        const contentDisposition = response.headers["content-disposition"];
        let fileName = "withdraw-report.xlsx";

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match && match[1]) {
            fileName = match[1].endsWith(".xlsx")
              ? match[1]
              : `${match[1]}.xlsx`;
          }
        }

        // Trigger download
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      // toast.error(error?.response?.data?.message || "Unable to download");

      // console.error("Download error:", error);
      let errorMessage = "Unable to download";

      if (error.response && error.response.data) {
        const data = error.response.data;

        if (data instanceof Blob) {
          // If backend sent JSON in blob (common for errors)
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const json = JSON.parse(reader.result);
              toast.error(json.message || errorMessage);
            } catch {
              toast.error(errorMessage);
            }
          };
          reader.readAsText(data);
        } else if (data.message) {
          toast.error(data.message);
        } else {
          toast.error(errorMessage);
        }
      } else {
        toast.error(errorMessage);
      }

      console.error("Download error:", error);
    } finally {
      setLoader(false);
    }
  }
  return (
    <>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "#1265c5" }} />
          </Stack>
        </div>
      )}
      <div>
        <div className="admin-top-container">
          <div className="admin-listText">User Invitations</div>
          {/* <div>
          <select
            className="listAdmin-showRecords"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
          >
            <option value={20}>Show No of Records</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={500}>500</option>
            <option value={1000}>1000</option>
            <option value={2000}>2000</option>
            <option value={5000}>5000</option>
          </select>
        </div> */}
          <div className="search-container">
            <div className="nav-search">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ border: "none", outline: "none", marginLeft: "6px" }}
              />
            </div>
          </div>

          <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {/* <DateRangePicker
                value={dateRange}
                format="DD-MM-YYYY"
                maxDate={dayjs()}
                onChange={(newValue) => {
                  setDateRange(newValue);

                  if (newValue[0] && newValue[1]) {
                    applyDateFilters(newValue);
                  }
                }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      "& .MuiOutlinedInput-root": {
                        height: 35,
                        width: 180,
                        "& fieldset": {
                          border: "1px solid #b8b9b9",
                        },
                        "&:hover fieldset": {
                          border: "1px solid #b8b9b9",
                        },
                        "&.Mui-focused fieldset": {
                          border: "1px solid #b8b9b9",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        color: "black",
                        fontSize: "0.85rem",
                      },
                      "& .MuiInputBase-input": {
                        padding: "4px 8px",
                        fontSize: "0.85rem",
                      },
                    },
                  },
                }}
              /> */}

              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                  setDateRange(update);

                  if (update[0] && update[1]) {
                    applyDateFilters(update);
                  }
                  // when cleared using cross icon
                  if (!update[0] && !update[1]) {
                    clearDateFilters();
                  }
                }}
                monthsShown={2}
                dateFormat="dd-MM-yyyy"
                placeholderText="Select date range"
                isClearable
                maxDate={new Date()}
                className="custom-date-range"
              />
            </LocalizationProvider>
          </div>
        </div>
        {dateRange?.[0] && dateRange?.[1] && (
          <div className="d-flex justify-content-between">
            <div>
              <button className="reset-btn" onClick={clearDateFilters}>
                Reset
              </button>
            </div>
            <div>
              <button className="download-btn" onClick={handleDownload}>
                <span className="me-1 fw-bold">
                  <GoDownload />
                </span>
                Download
              </button>
            </div>
          </div>
        )}
        {/* Tabs  */}
        <div className="wholesalerMenu mb-3">
          <div
            onClick={() => {
              setactiveEdit("wholesaler");
            }}
            className={`edit-menu ${
              activeEdit === "wholesaler" ? "activeEdit" : ""
            }`}
          >
            Wholesaler
          </div>
          <div
            onClick={() => {
              setactiveEdit("retailer");
            }}
            className={`edit-menu ${
              activeEdit === "retailer" ? "activeEdit" : ""
            }`}
          >
            Retailer
          </div>
        </div>
        {activeEdit === "wholesaler" && (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : userInvitedList.length > 0 ? (
                    userInvitedList
                      // .slice(
                      //   page * rowsPerPage,
                      //   page * rowsPerPage + rowsPerPage,
                      // )
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={`${activeEdit}-${row.id}`}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#F9FAFB" : "white",
                          }}
                        >
                          <TableCell align="center">{row.id}</TableCell>
                          <TableCell align="center">
                            {row.user ?? "-"}
                          </TableCell>

                          <TableCell align="center">
                            {row.invited_user_name}
                          </TableCell>
                          <TableCell align="center">
                            {row.mobile_number}
                          </TableCell>
                          <TableCell align="center">
                            {row.invited_user_location}
                          </TableCell>
                          <TableCell align="center">
                            {formatDate(row.created_at)}
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={columns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[
                20, 30, 50, 100, 500, 1000, 2000, 5000, 10000,
              ]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
        {activeEdit === "retailer" && (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : userInvitedList.length > 0 ? (
                    userInvitedList
                      // .slice(
                      //   page * rowsPerPage,
                      //   page * rowsPerPage + rowsPerPage,
                      // )
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={`${activeEdit}-${row.id}`}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#F9FAFB" : "white",
                          }}
                        >
                          <TableCell align="center">{row.id}</TableCell>
                          <TableCell align="center">
                            {row.user ?? "-"}
                          </TableCell>

                          <TableCell align="center">
                            {row.invited_user_name}
                          </TableCell>
                          <TableCell align="center">
                            {row.mobile_number}
                          </TableCell>
                          <TableCell align="center">
                            {row.invited_user_location}
                          </TableCell>

                          <TableCell align="center">
                            {formatDate(row.created_at)}
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={columns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[
                20, 30, 50, 100, 500, 1000, 2000, 5000, 10000,
              ]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </div>
    </>
  );
}
